export interface CurrencyDTO {
	code_name: string;
	name: string;
	description: string;
	image: string;
	value: number;
	hide_when_user_has_no_points: boolean;
}

export default class Currency {
	private _codeName: string;
	private _name: string;
	private _description: string;
	private _icon: string;
	private _value: number;
	private _hideWhenUserHasNoPoints: boolean;

	constructor(currency: CurrencyDTO) {
		this._codeName = currency.code_name;
		this._name = currency.name;
		this._description = currency.description;
		this._icon = currency.image;
		this._value = currency.value;
		this._hideWhenUserHasNoPoints = currency.hide_when_user_has_no_points;
	}

	codeName() {
		return this._codeName;
	}

	name() {
		return this._name;
	}

	description() {
		return this._description;
	}

	icon() {
		return this._icon;
	}

	value() {
		return this._value;
	}

	hideWhenUserHasNoPoints() {
		return this._hideWhenUserHasNoPoints;
	}

	absValue() {
		return Math.abs(this._value);
	}
}
